import { useState, useCallback } from "react"
import { Company } from "~/types/company"
import type { Dispatch, SetStateAction } from "react"

export const useCompanySave = (
  companies: Company[],
  setCompanyLists: Dispatch<SetStateAction<{ id: number; name: string }[]>>,
) => {
  const [isSaving, setIsSaving] = useState(false)

  const handleCompanySave = useCallback(
    async (domainIds: number[], companyListId?: number) => {
      if (domainIds.length === 0) return

      setIsSaving(true)
      try {
        const response = await fetch("/search/companies/save", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
              ?.content || "",
          },
          body: JSON.stringify({
            domain_ids: domainIds,
            company_list_id: companyListId,
          }),
        })

        if (!response.ok) {
          const error = await response.json()
          throw new Error(error.error || "Failed to save companies")
        }

        const data = await response.json()
        App.displayFlash(
          "success",
          `Successfully saved ${data.count} companies`,
        )

        // If a new list was created, update the company lists
        if (companyListId && data.company_list) {
          setCompanyLists((prev) => [
            ...prev,
            {
              id: data.company_list.id,
              name: data.company_list.name,
            },
          ])
        }
      } catch (error) {
        console.error("Error saving companies:", error)
        App.displayFlash(
          "error",
          error instanceof Error ? error.message : "Failed to save companies",
        )
      } finally {
        setIsSaving(false)
      }
    },
    [companies, setCompanyLists],
  )

  return {
    handleCompanySave,
    isSaving,
  }
}

